import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _get from 'lodash.get';
import Link from 'components/Link';
import { toggleLoginBox } from 'components/Login/redux';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import adBlockPromise from './AdBlockDetectUtils';
import s from './AdBlockerDetector.scss';

const AdBlockerDetector = props => {
  const moduleName = 'ad_blocker';
  let adBlockerPopup;
  const [adBlockDetected, setAdBlockDetected] = useState(false);

  const isUserLoggedIn = !!(props.userData && props.userData.isLoggedIn);

  const adBlockDetectionStart = () => {
    adBlockPromise.then(isAdBlockOn => {
      if (isAdBlockOn) {
        document.getElementsByTagName('body')[0].classList.add('noScroll');
        analyticsWrapper('ga4', {
          event: 'user_shown',
          type: `new_adblocker_popup`,
          label: isUserLoggedIn ? 'logged_in' : 'logged_out',
        });
      }
      setAdBlockDetected(isAdBlockOn);
      if (window && adBlockerPopup) {
        window.TimesApps.PopUpList[moduleName].callbacks.onShowCallback(
          isAdBlockOn,
        );
      }
    });
  };

  useEffect(() => {
    try {
      window.TimesApps.PopUpV2Manager.cmd.push(() => {
        if (
          window.TimesApps.PopUpV2Manager &&
          window.TimesApps.PopUpV2Manager?.register &&
          typeof window.TimesApps.PopUpV2Manager.register === 'function'
        ) {
          adBlockerPopup = window.TimesApps.PopUpV2Manager.register(
            moduleName,
            adBlockDetectionStart,
          );
        }
      });
    } catch (error) {
      console.log('Error in registering adblocker popup');
    }
  }, []);

  if (!adBlockDetected || props.openLogin) {
    return null;
  }

  return (
    <div className={s.popup}>
      <div className={s.background} />
      <div className={s.main}>
        <i className={s.toi_logo} />
        <h3>Uh-Oh! Looks like you&apos;re using an ad-blocker.</h3>
        <p>
          Advertisements help support our journalism. To keep reading
          here&apos;s what you can do.
        </p>
        <div className={`${s.links_wrap} ${isUserLoggedIn ? s.loggedin : ''}`}>
          <div className={s.adbtnwrapper}>
            <Link
              to="/blocked.cms"
              target="_blank"
              onClick={() => {
                analyticsWrapper('ga4', {
                  event: 'user_click',
                  type: `new_adblocker_popup`,
                  label: 'allow_ads',
                });
              }}
            >
              Allow Ads
            </Link>
            <Link
              className={s.subscribe_btn}
              to="/toi-plus/plans"
              target="_blank"
              onClick={() => {
                analyticsWrapper('ga4', {
                  event: 'user_click',
                  type: `new_adblocker_popup`,
                  label: 'subscribe_toi_plus',
                });
              }}
            >
              Subscribe to TOI+
            </Link>
          </div>
          <div className={s.sign_info}>
            <Link
              className={`${s.toiplusbtn}`}
              to="/toi-plus/plans"
              target="_blank"
              onClick={() => {
                analyticsWrapper('ga4', {
                  event: 'user_click',
                  type: `new_adblocker_popup`,
                  label: 'know_more',
                });
              }}
            >
              Know More about TOI+
            </Link>
            {!isUserLoggedIn && (
              <div className={`${s.signinprompt}`}>
                Already a Subscriber?{' '}
                <button
                  onClick={() => {
                    if (
                      props.toggleLoginBox &&
                      typeof props.toggleLoginBox === 'function'
                    ) {
                      props.toggleLoginBox(true);
                    }
                    analyticsWrapper('ga4', {
                      event: 'user_click',
                      type: `new_adblocker_popup`,
                      label: 'sign_in',
                    });
                  }}
                >
                  Sign In
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  openLogin: state.login.openLogin,
  userData: _get(state, 'login.userData', {}),
  // isPrime: state.isPrime,
});

const mapDispatchToProps = dispatch => ({
  toggleLoginBox: isOpen => {
    dispatch(toggleLoginBox(isOpen));
  },
});

AdBlockerDetector.propTypes = {
  openLogin: PropTypes.bool,
  userData: PropTypes.shape({}),
  toggleLoginBox: PropTypes.func,
};

AdBlockerDetector.defaultProps = {
  openLogin: false,
  userData: undefined,
  toggleLoginBox: () => {},
};

export default connect(mapStateToProps, mapDispatchToProps)(AdBlockerDetector);
